import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Filters, SearchOption } from '@emi/shared/models';
import { getSelectedFilters } from '@emi/shared/state/filters';
import { SkuSearchState } from '@emi/shared/state/sku-search';
import { select, Store } from '@ngrx/store';

export interface SearchFilterSummaryData {
    searchTerm: string;
    searchOptions: SearchOption;
}

@Component({
    selector: 'search-filter-summary',
    templateUrl: './search-filter-summary.component.html',
    styleUrls: ['./search-filter-summary.component.scss'],
})
export class SearchFilterSummaryComponent implements OnInit {

    public searchTerm = '';
    public searchOption: SearchOption;
    public filters: Filters;
    public defaultNoOfColumns = 3;

    constructor(
        private readonly store: Store<SkuSearchState>,
        public dialogRef: MatDialogRef<SearchFilterSummaryComponent>,
        @Inject(MAT_DIALOG_DATA) public data: SearchFilterSummaryData
    ) {}

    public ngOnInit(): void {
        this.searchTerm = this.data.searchTerm;
        this.searchOption = this.data.searchOptions;
        this.store.pipe(select(getSelectedFilters)).subscribe((x) => {
            this.filters = x;
        });
    }

    public closeSearchAndFilterSummary() {
        this.dialogRef.close();
    }

    public getColumns(array: Array<any>, columns: number = this.defaultNoOfColumns): Array<any> {
        const size = Math.ceil(array.length / columns);
        const result: any[] = [];
        for (let i = 0; i < array.length; i += size) {
            result.push(array.slice(i, i + size));
        }
        return result;
    }
}
